const formConfig = {
  FORM_ADDRESS_LIST: "addressListForm",
  FORM_ADDRESS_VALIDATION: "addressValidationForm",
  FORM_BILLING_ADDRESS: "BillingAddressForm",
  FORM_DELIVERY_METHOD: "deliveryMethodForm",
  FORM_GIFT_CARD: "giftCardForm",
  FORM_PROMO_CODE: "promoCodeForm",
  FORM_BILLING_PAYMENT: "billingPaymentForm",
  FORM_FORGOT_PASSWORD: "forgotPasswordForm",
  FORM_ACCOUNT_REGISTRATION: "accountRegistrationForm",
  FORM_SIGN_IN: "signInForm",
  FORM_CHECK_GIFT_CARD_BALANCE: "checkGiftCardBalanceForm",
  FORM_CONTACT_DIAMOND_SPECIALIST: "contactDiamondSpecialistForm",
  FORM_ROPIS_RESERVE: "ropisReserveForm",
  FORM_ROPIS_SEARCH: "ropisSearchForm",
  FORM_SEARCH_FILTER: "searchFilter",
  FORM_EMAIL_SIGNUP: "emailSignupModalForm",
  FORM_EMAIL_UPDATE: "emaiUpdateForm",
  FORM_CHANGE_PASSWORD: "passwordChangeForm",
  FORM_PERSONAL_INFORMATION: "personalInformationForm",
  FORM_RESET_PASSWORD: "FORM_RESET_PASSWORD",
  FORM_GIFT_MESSAGE: "giftMessageForm",
  FORM_CARD_OPERATION: "cardOperationsModal",
  FORM_EMAIL_SIGNUP_PAGE: "emailSignupForm",
  FORM_CHANGE_EMAIL: "changeEmailForm",
  FORM_RECIEVE_EMAIL: "recieveEmailForm",
  FORM_CONTACT_CUSTOMER_CARE: "contactCustomerCareForm",
  FORM_STAY_IN_TOUCH: "stayInTouchForm",
  FORM_APPLY_GIFT_CARD: "giftCardForm",
  FORM_COUNTRY_SELECT: "FORM_COUNTRY_SELECT",
  FORM_EMAIL_ITEM_SEND: "emailItemSendForm",
  FORM_SHIPPING_ADDRESS: "checkoutShippingInlineAddressForm",
  FORM_SHIPPING_ADDRESS_MODAL: "checkoutShippingModalAddressForm",
  FORM_AFFIRM_BILLING: "affirmBillingForm",
  FORM_ASM_NEW_USER: "asmNewCustomerForm",
  FORM_ASM_FIND_USER: "asmFindCustomerForm",
  FORM_FIND_ASM_USER_CART: "asmFindAsmUserCart",
  FORM_ASM_PRICE_OVER_RIDE: "asmPriceOverRideForm",
  FORM_ASM_FIND_USER_WRAPPER: "asmFindCustomerWrapperForm",
  FORM_ASM_FIND_USER_PAGINATION: "asmFindCustomerPaginationForm",
  FORM_ASM_ORDER_REFERENCE_NUMBER: "asmOrderReferenceNumberForm",
  FORM_ASM_SHIPPING_PRICE_OVER_RIDE: "asmShippingPriceOverrideForm",
  FORM_ASM_SELECT_MULTIPLE_CUSTOMERS: "asmSelectCustomersToMergeForm",
  FORM_NOTIFY_USER: "formNotifyUser",
  FORM_REFERRAL_NUMBER: "fromReferralNumber",
  FORM_DO_NOT_SELL_MY_INFORMATION: "doNotSellMyInfoForm",
  FORM_TRACK_YOUR_ORDER: "trackYourOrderForm",
  FORM_NOTIFICATIONS_SIGNUP: "notificationsSignupForm",
}

export default formConfig
